import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Grid } from '@alfa-bank/site-grid-universal';
import { ProfitabilityRenderer } from '@alfa-bank/site-invest-emitents-common/components/renderer';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';

import { ProfitabilityCell as Component } from './component';
import type { IDepsDesktop, TProfitabilityCellDesktop } from './models';
import styles from './styles.css';

export const ProfitabilityCellDesktop = createWidget<IDepsDesktop, TProfitabilityCellDesktop>({
    Grid,
    ProfitabilityRenderer,
    Text,
    styles,
})(Component);
